<template>
  <v-form ref="form" class="mx-2" method="post" enctype="multipart/form-data">
    <v-container id="SERVIZI" fluid tag="section">
      <v-row>
        <v-col :cols="isEditServizi ? '4' : '12'">
          <base-material-card
            color="white"
            iconcolor="darkred"
            icon="mdi-checkbox-multiple-blank-outline"
            :title="$t('servizi.titolo')"
            class="px-5 py-3"
          >
            <v-container v-if="isCreatedCorrectly" v-resize="onContainerChange">
              <v-row>
                <v-col>
                  <v-card-title>
                    <v-text-field
                      v-model="search"
                      append-icon="mdi-magnify"
                      :label="$t('servizi.ricerca')"
                      single-line
                      hide-details
                    ></v-text-field>
                  </v-card-title>
                </v-col>
                <v-col align="end">
                  <v-btn
                    color="darkred"
                    width="180px"
                    @click="onNuovoServizio"
                  >
                    <v-icon left> mdi-plus-circle-outline </v-icon>
                    {{ $t("servizi.nuovoServizio") }}
                  </v-btn>
                  <v-btn color="darkred" width="180px" @click="onExportGrid" v-show="false">
                    <v-icon left> mdi-export </v-icon>
                    {{ $t("esporta") }}
                  </v-btn>
                </v-col>
              </v-row>
            </v-container>
            <v-data-table
              style="max-height:600px; overflow:auto"
              id="tblServizi"
              :items="servizi.source"
              :headers="headersColumns"
              :search="search"
              :value="[servizi.selected]"
              @click:row="onTableRowClick"
              single-select
              :items-per-page="-1"
              class="elevation-1"
              :loading="isloading_servizi"
              loading-text="Caricamento dati in corso..."
            >
            </v-data-table>
          </base-material-card>
        </v-col>

        <v-col v-if="isEditServizi" cols="8">
          <base-material-card
            color="white"
            iconcolor="darkred"
            icon="mdi-checkbox-blank-outline"
            :title=" $t('servizi.servizio') + ': ' + servizi.selected.cDescrizione"
            class="px-5 py-3"
          >
          <v-card flat>
              <v-row>
                <v-card-title
                  class="black--text"
                  style="margin-bottom: 20px; margin-top: 20px"
                  >{{ $t("anagrafica") }}
                </v-card-title>
              </v-row>
              <v-row>
                <v-col>
                  <v-text-field
                    v-model="servizi.selected.cSigla"
                    :label="$t('servizi.siglaObbl')"
                    :rules="[rules.required]"
                    maxlength="10"
                    :disabled="shouldDisable"
                  >
                  </v-text-field>
                </v-col>
                <v-col>
                  <v-text-field
                    v-model="servizi.selected.cDescrizione"
                    :label="$t('servizi.descrizioneObbl')"
                    :rules="[rules.required]"
                    maxlength="50"
                    :disabled="shouldDisable"
                  >
                  </v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-select
                    :items="eEnti"
                    return-object
                    item-text="cDescrizione"
                    item-value="id"
                    :label="$t('servizi.enteObbl')"
                    :rules="[rules.selectRequired]"
                    v-model="servizi.selected.enteDTO"
                    :disabled="shouldDisable"
                    @change="onEnteChanged($event)"
                  >
                  </v-select>
                </v-col>
                <v-col>
                  <v-select
                    :items="ePoli"
                    return-object
                    item-text="cDescrizione"
                    item-value="id"
                    :label="$t('servizi.poloObbl')"
                    :rules="[rules.selectRequired]"
                    v-model="servizi.selected.poloDTO"
                    :disabled="shouldDisable"
                  >
                  </v-select>
                </v-col>
                <v-col>
                  <v-select
                    :items="eUtenti"
                    return-object
                    item-text="cNomeCognome"
                    item-value="id"
                    :label="$t('servizi.utente')"
                    v-model="servizi.selected.userDTO"
                    :disabled="shouldDisable"
                  >
                  </v-select>
                </v-col>
              </v-row>
              <v-row> 
                <v-col>
                  
                </v-col>
              </v-row>

              <v-divider class="mx-4"></v-divider>
              <v-row
                style="margin-top: 20px; margin-left: 20px; margin-bottom: 10px"
              >
                <v-alert
                  id="alertDettaglio"
                  shaped
                  :value="isAlertDetailVisible"
                  :type="alertType"
                  dismissible
                >
                  {{ messaggioAlert }}
                </v-alert>
              </v-row>

              <v-row
                style="margin-top: 20px; margin-left: 20px; margin-bottom: 10px"
              >
                <v-btn
                  tile
                  color="darkred"
                  v-if="!isHidden"
                  v-on:click="isHidden = true"
                  @click="onEditClick"
                >
                  <v-icon left> mdi-pencil </v-icon>
                  {{ $t("modifica") }}
                </v-btn>
                <v-btn
                  tile
                  color="darkred"
                  v-if="isHidden"
                  @click="onSaveClick"
                >
                  <v-icon left> mdi-content-save </v-icon>
                  {{ $t("salva") }}
                </v-btn>
                <v-btn
                  tile
                  color="darkred"
                  @click="onDisattivaClick"
                >
                  <v-icon left> mdi-delete </v-icon>
                  {{ $t("disattiva") }}
                </v-btn>

                <v-btn
                  id="btnChiudi"
                  tile
                  color="darkred"
                  @click="onCloseDetail"
                >
                  <v-icon left> mdi-door-open </v-icon>
                  {{ $t("chiudi") }}
                </v-btn>

                <v-dialog v-model="dialogDisattivaServizio" max-width="500px">
                <v-card>
                  <v-card-title class="text-h5"
                    >Sei sicuro di voler disattivare il servizio selezionato?
                  </v-card-title>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                      color="blue darken-1"
                      text
                      @click="closeDisattivaServizio"
                      >Annulla</v-btn
                    >
                    <v-btn
                      color="blue darken-1"
                      text
                      @click="confirmDisattivaServizio"
                      >OK</v-btn
                    >
                    <v-spacer></v-spacer>
                  </v-card-actions>
                </v-card>
              </v-dialog>                
              </v-row>
            </v-card>
          </base-material-card>
        </v-col>        
      </v-row>
      <v-row>
        <v-alert
          id="alertGrid"
          shaped
          :value="isAlertGridVisible"
          :type="alertType"
          dismissible
        >
          {{ messaggioAlert }}
        </v-alert>
      </v-row>      
    </v-container>
  </v-form>
</template>

<script>
import Vue from "vue";
import Component from "vue-class-component";

import i18n from "@/i18n";
import Utils from "@/utils/Utils";

import TipologicheService from "@/service/TipologicheService";
import ServiziService from "@/service/ServiziService";
import EntiService from "@/service/EntiService";
import PoliService from "@/service/PoliService";
import UtentiService from "@/service/UtentiService";

@Component
export default class Servizi extends Vue {

  servizi = {
    selected: null,
    source: [],
  };

  headersColumns = [
    {
      text: "Sigla",
      align: "start",
      value: "cSigla",
    },
    { text: "Descrizione", value: "cDescrizione" },
    { text: "Ente", value: "enteDTO.cDescrizione" },
    { text: "Polo", value: "poloDTO.cDescrizione" },
  ];

  eEnti = [];
  
  ePoli = [];

  eUtenti = [];

  // Variabili
  isEditServizi = false;
  isAlertGridVisible = false;
  isAlertDetailVisible = false;
  isCreatedCorrectly = false;
  isDisattivaEnabled = false;
  isloading_servizi = false;
  isNewServizio = false;
  shouldDisable = true;
  enteShouldDisable = true;
  isHidden = false;
  saveClicked = false;
  dialogDisattivaServizio = false;

  servizioTempl = [];

  dimension = 0;

  messaggioAlert = "";
  alertType = "error";
  search = "";

  rules = Utils.rules;

  created() {
    let verLoadingPage = Utils.verifyLoadingPage(this.$store, "W_PROFILAZIONEUTENTE");
    switch (verLoadingPage) {
      case 0: // All OK
        this.isCreatedCorrectly = true;
        var enteId = this.$store.state.enteSel.id;
        this.loadServizi();
        this.loadTemplateServizio();
        this.loadEnti();
        this.loadPoli(0);
        break;

      case 1: // Utente non loggato
        AuthService.logout();
        break;

      case 2: // Ente non selezionato
        this.$router.push({ name: "Dashboard" });
        break;

      case 3: // Permesso alla pagina non presente
        this.$router.push({ name: "Dashboard" });
    }
  }

  onTableRowClick(enteSel) {
    // Setto la riga selezionata
    this.servizi.selected = enteSel;

    console.log("Servizio selezionato: ");
    console.log(this.servizi.selected);

    // Carico gli utenti speciali legati al servizio
    this.loadUtentiSpeciali(this.servizi.selected.id);
    this.onEnteChanged();

    this.isHidden = false;
    this.shouldDisable = true;
    this.isEditServizi = true;
    this.isNewServizio = false;
  }

  onExportGrid() {
    // TODO
  }

  onContainerChange() {
    let self = this;
    // console.log("onContainerChange");
    self.$nextTick(function () {
      self.dimension = document.getElementById("tblServizi").offsetWidth;
      return self.dimension;
    });
  }

  onEditClick() {
    this.shouldDisable = false;
  }

  onSaveClick() {
    this.saveClicked = true;
    var formIsValid = this.$refs.form.validate();
    if (!formIsValid) {
      this.alertType = "error";
      // In caso di errore del salvataggio continuare con l'editing
      this.messaggioAlert = i18n.t("erroreCampiObbligatori");
      this.showHide_alertDetail(8000);
    } else {
      // TODO
      if (this.servizi.selected.id > 0) {
        // Salvo il dato sul DB
        this.saveServizioDto(this.servizi.selected.id);
      } else {
        // Creo il nuovo record
        this.createServizioDto();
      }
    }
  }

  onCloseDetail() {
    this.isEditServizi = false;
    this.onContainerChange();
    this.shouldDisable = true;
    this.isHidden = false;

  }

  onNuovoServizio() {
// Chiudo l'oggetto precedente prima di aprire il nuovo
    this.$refs.form.resetValidation();
    this.saveClicked = false;
    this.isNewServizio = true;

    // Impostazione variabili
    this.isEditServizi = true;
    this.shouldDisable = false;
    this.isHidden = true;
    // Svuoto oggetti collegati
    
    this.onContainerChange();
    
    this.servizi.selected = Object.assign({}, this.servizioTempl);
    this.eUtenti = [];
    this.onEnteChanged();
  }

  onEnteChanged() {
    if ( !Utils.isNullOrUndefined(this.servizi.selected.enteDTO) &&
      this.servizi.selected.enteDTO.id >= 0) {
      // Carico gli utenti
      this.loadUtenti(this.servizi.selected.enteDTO.id);
    }
  }

  onDisattivaClick() {
    this.dialogDisattivaServizio = true;
  }

  confirmDisattivaServizio() {
    this.disattivaServizioDto(this.servizi.selected.id);
    this.dialogDisattivaServizio = false;
  }

  closeDisattivaServizio() {
    this.dialogDisattivaServizio = false;
  }

  showHide_alertGrid(millisecondInterval, event) {
    //console.log('Hide alert');
    this.isAlertGridVisible = true;
    // `event` is the native DOM event
    window.setTimeout(() => {
      this.isAlertGridVisible = false;
      console.log(
        "hide alert after " + millisecondInterval / 1000 + " seconds"
      );
    }, millisecondInterval);
  }

  showHide_alertDetail(millisecondInterval, event) {
    //console.log('Hide alert');
    this.isAlertDetailVisible = true;
    // `event` is the native DOM event
    window.setTimeout(() => {
      this.isAlertDetailVisible = false;
      //console.log("hide alert after " + millisecondInterval/1000 + " seconds");
    }, millisecondInterval);
  }

  /// *************************
  /// DATABASE
  /// *************************

  loadServizi() {
    var self = this;
    var enteId = 0;
    self.isloading_servizi = true;
    ServiziService.getServizi(
      enteId,
      (resp) => {
        self.isloading_servizi = false;
        console.log("GetServizi");
        console.log(resp);

        self.servizi.source = resp;
      },
      (err) => {
        console.log("Errore GetServizi");
        console.log(err);
        self.alertType = "error";
        self.messaggioAlert = i18n.t("erroreCaricamentoServizi");
        self.showHide_alertGrid(8000);
        self.isloading_servizi = false;
      }
    );
  }

  loadTemplateServizio() {
    var self = this;

    ServiziService.getTemplateServizio(
      (resp) => {
        console.log("getTemplateServizio:");
        console.log(resp);
        self.servizioTempl = resp;
      },
      (err) => {
        console.log(err);
        self.alertType = "error";
        self.messaggioAlert = Utils.getErrorMessage(err);
        self.showHide_alertDetail(5000);
      }
    );
  }

  loadEnti() {
    var self = this;

    EntiService.getEnti(
      (resp) => {
        self.isloading_enti = false;
        console.log("GetEnti");
        console.log(resp);

        self.eEnti = resp;
      },
      (err) => {
        console.log("Errore GetEnti");
        console.log(err);
        self.alertType = "error";
        self.messaggioAlert = i18n.t("erroreCaricamentoEnti");
        self.showHide_alertGrid(8000);
        self.isloading_enti = false;
      }
    );
  }

  loadPoli(enteId) {
    var self = this;

    PoliService.getPoli(
      enteId,
      (resp) => {
        self.isloading_enti = false;
        console.log("GetPoli");
        console.log(resp);

        self.ePoli = resp;
      },
      (err) => {
        console.log("Errore GetPoli");
        console.log(err);
        self.alertType = "error";
        self.messaggioAlert = i18n.t("erroreCaricamentoPoli");
        self.showHide_alertGrid(8000);
        self.isloading_enti = false;
      }
    );
  }

  loadUtentiSpeciali(idServ) {
    var self = this;

    UtentiService.getUsersServizio(
      idServ,
      (resp) => {
        console.log("GetUsersServizio");
        console.log(resp);

        self.t_userservizio = resp;
      },
      (err) => {
        console.log("Errore GetUsersServizio");
        console.log(err);
      }
    );
  }

  saveServizioDto(id) {
    var self = this;

    ServiziService.updateServizio(
      self.servizi.selected,
      (resp) => {
        console.log("updateServizio");
        console.log(resp);
        if (resp.result == 1) {
          // Buon fine
          self.alertType = "success";
          self.messaggioAlert = resp.userMsg.message;
          self.showHide_alertDetail(5000);
          // Aggiorno la griglia principale
          self.updateGridServizio(id);
        } else {
          // KO
          self.alertType = "error";
          self.messaggioAlert = resp.userMsg.message;
          self.showHide_alertDetail(8000);
        }

        self.isHidden = !self.isHidden;
        self.shouldDisable = true;
        console.log(resp.userMsg.message);
      },
      (err) => {
        console.log(err);
        self.alertType = "error";
        self.messaggioAlert = Utils.getErrorMessage(err);
        self.showHide_alertDetail(8000);
      }
    );
  }

  createServizioDto() {
    var self = this;

    ServiziService.createServizio(
      self.servizi.selected,
      (resp) => {
        console.log("CreateServizio");
        console.log(resp);
        if (resp.result == 1) {
          // Buon fine
          self.alertType = "success";
          self.messaggioAlert = resp.userMsg.message;
          self.showHide_alertDetail(5000);
          // Aggiorno la griglia principale
          self.updateGridServizio(resp.idNewObject);
          self.isNewServizio = false;
        } else {
          // KO
          self.alertType = "error";
          self.messaggioAlert = resp.userMsg.message;
          self.showHide_alertDetail(8000);
        }

        self.isHidden = !self.isHidden;
        self.shouldDisable = true;
        console.log(resp.userMsg.message);
      },
      (err) => {
        console.log(err);
        self.alertType = "error";
        self.messaggioAlert = Utils.getErrorMessage(err);
        self.showHide_alertDetail(8000);
      }
    );
  }

  updateGridServizio(id, onSuccess) {
    var self = this;

    ServiziService.getServizio(
      id,
      (resp) => {
        console.log("Servizio:");
        console.log(resp);

        var servizioTmp = resp;

        if (typeof onSuccess === "function") onSuccess(resp);
        // Aggiorno la griglia
        var found = false;
        for (let i = 0; i < self.servizi.source.length; i++) {
          var item = self.servizi.source[i];
          if (item.id == id) {
            found = true;
            self.servizi.source.splice(i, 1);
            self.servizi.source.push(servizioTmp);
            self.servizi.selected = servizioTmp;
            break;
          }
        }
        if (!found) {
          // Caso di nuovo oggetto
          self.servizi.source.push(servizioTmp);
          self.servizi.selected = servizioTmp;
        }
      },
      (err) => {
        console.log(err);
        self.alertType = "error";
        self.messaggioAlert = Utils.getErrorMessage(err);
        self.showHide_alertGrid(8000);
      }
    );
  }

  disattivaServizioDto(id) {
    var self = this;

    ServiziService.deleteServizio(
      self.servizi.selected.id,
      (resp) => {
        console.log("deleteServizio");
        console.log(resp);

        if (resp.result == 1) {
          // Buon fine
          self.alertType = "success";
          self.messaggioAlert = resp.userMsg.message;
          self.showHide_alertGrid(5000);
          // Azzero l'oggetto
          self.servizi.selected = null;
          // Ricarico la griglia
          self.loadServizi();
          self.isEditServizi = false;
        } else {
          // KO
          self.alertType = "error";
          self.messaggioAlert = resp.userMsg.message;
          self.showHide_alertDetail(5000);
        }

        self.isHidden = !self.isHidden;
        self.shouldDisable = true;
        console.log(resp.userMsg.message);
      },
      (err) => {
        console.log(err);
        self.alertType = "error";
        self.messaggioAlert = Utils.getErrorMessage(err);
        self.showHide_alertDetail(5000);
      }
    );
  }

  loadUtenti(enteId) {
    var self = this;
    UtentiService.getUsersEnti(
      enteId,
      (resp) => {
        console.log("GetUtenti");
        console.log(resp);

        self.eUtenti = resp;
      },
      (err) => {
        console.log("Errore GetUtenti");
        console.log(err);
      }
    );
  }

}
</script>